import { useState } from "react";
import { Badge, Button, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import { RxSlider } from "react-icons/rx";
import { TfiCheckBox } from "react-icons/tfi";
import { PiPasswordBold } from "react-icons/pi";
import { FiLink } from "react-icons/fi";
import { GoFile, GoNumber } from "react-icons/go";
import { TbCalendarTime } from "react-icons/tb";
import { MdOutlineMailOutline, MdOutlineTextFields } from "react-icons/md";
import { IoRadioButtonOnOutline, IoTimeOutline } from "react-icons/io5";
import {
  BsCalendar2Month,
  BsCalendar4Week,
  BsCalendarDate,
  BsTelephone,
  BsTextareaResize,
} from "react-icons/bs";

const FieldCustomize = ({ fields, setFields, openCustomization, setOpenCustomization, setOpenHistory }) => {
  const [openModule, setOpenModule] = useState("general")
  const FIELD_TYPES = [
    { label: "Text", type: "text", icon: MdOutlineTextFields },
    { label: "Textarea", type: "textarea", icon: BsTextareaResize },
    { label: "Number", type: "number", icon: GoNumber },
    { label: "Tel", type: "tel", icon: BsTelephone },
    { label: "Date", type: "date", icon: BsCalendarDate },
    { label: "Time", type: "time", icon: IoTimeOutline },
    { label: "Date Time", type: "datetime-local", icon: TbCalendarTime },
    { label: "Email", type: "email", icon: MdOutlineMailOutline },
    { label: "File", type: "file", icon: GoFile },
    { label: "URL", type: "url", icon: FiLink },
    { label: "Week", type: "week", icon: BsCalendar4Week },
    { label: "Month", type: "month", icon: BsCalendar2Month },
    { label: "Password", type: "password", icon: PiPasswordBold },
    { label: "Radio", type: "radio", icon: IoRadioButtonOnOutline },
    { label: "Checkbox", type: "checkbox", icon: TfiCheckBox },
    { label: "Range", type: "range", icon: RxSlider },
  ];

  const addField = (field) => {
    setFields((prev) => [
      ...prev,
      {
        ...field,
        id: Date.now().toString(),
      },
    ]);
  };

  return (
    <>
      <div
        className="p-3 overflow-auto"
        style={{ height: fields.length > 0 ? "calc(100vh - 175px)" : "calc(100vh - 123px)" }}
      >
        <Row>
          {(openCustomization && fields.length > 0) ? (
            <Form.Group as={Col} md={12}>
              <div className="hstack gap-2">
                <Button size="sm" style={{ fontSize: 12 }} variant={openModule === "general" ? "primary" : "outline-primary"} onClick={() => setOpenModule("general")}>General</Button>
                <Button size="sm" style={{ fontSize: 12 }} variant={openModule === "validation" ? "primary" : "outline-primary"} onClick={() => setOpenModule("validation")}>Validation</Button>
                <Button size="sm" style={{ fontSize: 12 }} variant={openModule === "customization" ? "primary" : "outline-primary"} onClick={() => setOpenModule("customization")}>Customization</Button>
              </div>
              {openModule === "general" && (
                <div className="overflow-auto pt-3" style={{ height: `calc(100vh - 235px)` }}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                      Field Label
                    </Form.Label>
                    <Form.Control
                      // value={templateName}
                      // onChange={(e) => setTemplateName(e.target.value)}
                      placeholder="Enter Field Label"
                      style={{ fontSize: 12 }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                      Field Name
                    </Form.Label>
                    <Form.Control
                      // value={templateName}
                      // onChange={(e) => setTemplateName(e.target.value)}
                      placeholder="Enter Field Name"
                      style={{ fontSize: 12 }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                      Field Help
                    </Form.Label>
                    <Form.Control
                      // value={templateName}
                      // onChange={(e) => setTemplateName(e.target.value)}
                      placeholder="Enter Field Help"
                      style={{ fontSize: 12 }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                      Field placeholder
                    </Form.Label>
                    <Form.Control
                      // value={templateName}
                      // onChange={(e) => setTemplateName(e.target.value)}
                      placeholder="Enter Field placeholder"
                      style={{ fontSize: 12 }}
                    />
                  </Form.Group>
                </div>
              )}
              {openModule === "validation" && (
                <div className="overflow-auto pt-3" style={{ height: `calc(100vh - 235px)` }}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                      Manage Date Range
                    </Form.Label>
                    <Form.Select
                      className="interactive-input"
                      style={{ fontSize: 12, padding: "6px 15px" }}
                    >
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                      From
                    </Form.Label>
                    <Form.Control
                      type="date"
                      // value={templateName}
                      // onChange={(e) => setTemplateName(e.target.value)}
                      placeholder="Enter Field placeholder"
                      style={{ fontSize: 12 }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                      To
                    </Form.Label>
                    <Form.Control
                      type="date"
                      // value={templateName}
                      // onChange={(e) => setTemplateName(e.target.value)}
                      placeholder="Enter Field placeholder"
                      style={{ fontSize: 12 }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                      Manage Number Range
                    </Form.Label>
                    <Form.Select
                      className="interactive-input"
                      style={{ fontSize: 12, padding: "6px 15px" }}
                    >
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                      Min Number
                    </Form.Label>
                    <Form.Control
                      type="number"
                      // value={templateName}
                      // onChange={(e) => setTemplateName(e.target.value)}
                      placeholder="Enter Min Number"
                      style={{ fontSize: 12 }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                      Max Number
                    </Form.Label>
                    <Form.Control
                      type="number"
                      // value={templateName}
                      // onChange={(e) => setTemplateName(e.target.value)}
                      placeholder="Enter Max Number "
                      style={{ fontSize: 12 }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                      Field Required
                    </Form.Label>
                    <Form.Select
                      className="interactive-input"
                      style={{ fontSize: 12, padding: "6px 15px" }}
                    >
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </Form.Select>
                  </Form.Group>
                </div>
              )}
              {openModule === "customization" && (
                <div className="overflow-auto pt-3" style={{ height: `calc(100vh - 235px)` }}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                      Column Size
                    </Form.Label>
                    <Form.Select
                      className="interactive-input"
                      style={{ fontSize: 12, padding: "6px 15px" }}
                    >
                      <option value="100">100%</option>
                      <option value="50">50%</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                      Label Customization
                    </Form.Label>
                    <div className="p-3 border br3 bg-light">
                      <div className="mb-3 hstack gap-4">
                        <Form.Group className="hstack gap-2">
                          <Form.Check
                            type="checkbox"
                          // onChange={(e) => handleUpdateFormField(fieldData?.id, "labelBold", e.target.checked)}
                          // checked={!!fieldData?.labelBold}
                          />
                          <Form.Label className="m-0" style={{ fontSize: 12 }}>
                            <b>Bold</b>
                          </Form.Label>
                        </Form.Group>
                        <Form.Group className="hstack gap-2">
                          <Form.Check
                            type="checkbox"
                          // onChange={(e) => handleUpdateFormField(fieldData?.id, "labelItalic", e.target.checked)}
                          // checked={!!fieldData?.labelItalic}
                          />
                          <Form.Label className="m-0" style={{ fontSize: 12 }}>
                            <i>Italic</i>
                          </Form.Label>
                        </Form.Group>
                        <Form.Group className="hstack gap-2">
                          <Form.Check
                            type="checkbox"
                          // onChange={(e) => handleUpdateFormField(fieldData?.id, "labelUnderline", e.target.checked)}
                          // checked={!!fieldData?.labelUnderline}
                          />
                          <Form.Label className="m-0" style={{ fontSize: 12 }}>
                            <u>Underline</u>
                          </Form.Label>
                        </Form.Group>
                      </div>
                      <Form.Group className="mb-2">
                        <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                          Label Color
                        </Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="text" placeholder="#000000"
                            style={{ fontSize: 12 }}
                          // onChange={(e) => handleUpdateFormField(fieldData?.id, "labelColor", e.target.value)}
                          // value={fieldData?.labelColor}
                          />
                          <Form.Control
                            type="color"
                            className="p-0 position-absolute"
                            // onChange={(e) => handleUpdateFormField(fieldData?.id, "labelColor", e.target.value)}
                            // value={fieldData?.labelColor}
                            style={{
                              width: 20,
                              height: 20,
                              right: 5,
                              top: 5,
                              fontSize: 12
                            }}
                          />
                        </div>
                      </Form.Group>
                      <Form.Group className="mb-2">
                        <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                          Font Size
                        </Form.Label>
                        <div className="position-relative">
                          <InputGroup>
                            <Form.Control
                              type="number"
                              placeholder="35"
                              style={{ fontSize: 12 }}
                            // onChange={(e) => handleUpdateFormField(fieldData?.id, "labelSize", e.target.value)}
                            // value={fieldData?.labelSize}
                            />
                            <InputGroup.Text
                              id="basic-addon1"
                              className="br3 fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              PX
                            </InputGroup.Text>
                          </InputGroup>
                        </div>
                      </Form.Group>
                    </div>
                  </Form.Group>
                </div>
              )}
            </Form.Group>
          ) : (
            FIELD_TYPES.map((field) => (
              <Form.Group as={Col} md={4} sm={6} className="mb-3">
                <Button
                  size="sm"
                  variant="light"
                  key={field.label}
                  className="d-flex flex-column align-items-center justify-content-center"
                  style={{ width: 70, height: 70 }}
                  onClick={() => addField(field)}
                >
                  <field.icon size={20} />
                  <span style={{ fontSize: 12 }}>{field.label}</span>
                </Button>
              </Form.Group>
            ))
          )}
        </Row>
      </div>
      {fields.length > 0 && (
        <div className="d-flex justify-content-end gap-2 p-2 border-top">
          {openCustomization ? (
            <Button
              size="sm"
              variant="danger"
              onClick={() => setOpenCustomization("")}
            >
              Close
            </Button>
          ) : (
            <Button
              size="sm"
              variant="light"
              onClick={() => setOpenHistory?.("formEntry")}
            >
              Preview
            </Button>
          )}
          <Button size="sm">Save</Button>
        </div>
      )}
    </>
  );
};

export default FieldCustomize;
